// Copyright 2021-2024 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

// @generated by protoc-gen-connect-es v1.3.0 with parameter "target=ts,import_extension=none"
// @generated from file kubeappsapis/plugins/kapp_controller/packages/v1alpha1/kapp_controller.proto (package kubeappsapis.plugins.kapp_controller.packages.v1alpha1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import {
  CreateInstalledPackageRequest,
  CreateInstalledPackageResponse,
  DeleteInstalledPackageRequest,
  DeleteInstalledPackageResponse,
  GetAvailablePackageDetailRequest,
  GetAvailablePackageDetailResponse,
  GetAvailablePackageSummariesRequest,
  GetAvailablePackageSummariesResponse,
  GetAvailablePackageVersionsRequest,
  GetAvailablePackageVersionsResponse,
  GetInstalledPackageDetailRequest,
  GetInstalledPackageDetailResponse,
  GetInstalledPackageResourceRefsRequest,
  GetInstalledPackageResourceRefsResponse,
  GetInstalledPackageSummariesRequest,
  GetInstalledPackageSummariesResponse,
  UpdateInstalledPackageRequest,
  UpdateInstalledPackageResponse,
} from "../../../../core/packages/v1alpha1/packages_pb";
import { MethodKind } from "@bufbuild/protobuf";
import {
  AddPackageRepositoryRequest,
  AddPackageRepositoryResponse,
  DeletePackageRepositoryRequest,
  DeletePackageRepositoryResponse,
  GetPackageRepositoryDetailRequest,
  GetPackageRepositoryDetailResponse,
  GetPackageRepositoryPermissionsRequest,
  GetPackageRepositoryPermissionsResponse,
  GetPackageRepositorySummariesRequest,
  GetPackageRepositorySummariesResponse,
  UpdatePackageRepositoryRequest,
  UpdatePackageRepositoryResponse,
} from "../../../../core/packages/v1alpha1/repositories_pb";

/**
 * @generated from service kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerPackagesService
 */
export const KappControllerPackagesService = {
  typeName: "kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerPackagesService",
  methods: {
    /**
     * GetAvailablePackageSummaries returns the available packages managed by the 'kapp_controller' plugin
     *
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerPackagesService.GetAvailablePackageSummaries
     */
    getAvailablePackageSummaries: {
      name: "GetAvailablePackageSummaries",
      I: GetAvailablePackageSummariesRequest,
      O: GetAvailablePackageSummariesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetAvailablePackageDetail returns the package details managed by the 'kapp_controller' plugin
     *
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerPackagesService.GetAvailablePackageDetail
     */
    getAvailablePackageDetail: {
      name: "GetAvailablePackageDetail",
      I: GetAvailablePackageDetailRequest,
      O: GetAvailablePackageDetailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetAvailablePackageVersions returns the package versions managed by the 'kapp_controller' plugin
     *
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerPackagesService.GetAvailablePackageVersions
     */
    getAvailablePackageVersions: {
      name: "GetAvailablePackageVersions",
      I: GetAvailablePackageVersionsRequest,
      O: GetAvailablePackageVersionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetInstalledPackageSummaries returns the installed packages managed by the 'kapp_controller' plugin
     *
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerPackagesService.GetInstalledPackageSummaries
     */
    getInstalledPackageSummaries: {
      name: "GetInstalledPackageSummaries",
      I: GetInstalledPackageSummariesRequest,
      O: GetInstalledPackageSummariesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetInstalledPackageDetail returns the requested installed package managed by the 'kapp_controller' plugin
     *
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerPackagesService.GetInstalledPackageDetail
     */
    getInstalledPackageDetail: {
      name: "GetInstalledPackageDetail",
      I: GetInstalledPackageDetailRequest,
      O: GetInstalledPackageDetailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CreateInstalledPackage creates an installed package based on the request.
     *
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerPackagesService.CreateInstalledPackage
     */
    createInstalledPackage: {
      name: "CreateInstalledPackage",
      I: CreateInstalledPackageRequest,
      O: CreateInstalledPackageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * UpdateInstalledPackage updates an installed package based on the request.
     *
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerPackagesService.UpdateInstalledPackage
     */
    updateInstalledPackage: {
      name: "UpdateInstalledPackage",
      I: UpdateInstalledPackageRequest,
      O: UpdateInstalledPackageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * DeleteInstalledPackage deletes an installed package based on the request.
     *
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerPackagesService.DeleteInstalledPackage
     */
    deleteInstalledPackage: {
      name: "DeleteInstalledPackage",
      I: DeleteInstalledPackageRequest,
      O: DeleteInstalledPackageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetInstalledPackageResourceRefs returns the references for the Kubernetes resources created by
     * an installed package.
     *
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerPackagesService.GetInstalledPackageResourceRefs
     */
    getInstalledPackageResourceRefs: {
      name: "GetInstalledPackageResourceRefs",
      I: GetInstalledPackageResourceRefsRequest,
      O: GetInstalledPackageResourceRefsResponse,
      kind: MethodKind.Unary,
    },
  },
} as const;

/**
 * @generated from service kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerRepositoriesService
 */
export const KappControllerRepositoriesService = {
  typeName:
    "kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerRepositoriesService",
  methods: {
    /**
     * AddPackageRepository add an existing package repository to the set of ones already managed by the 'kapp_controller' plugin
     *
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerRepositoriesService.AddPackageRepository
     */
    addPackageRepository: {
      name: "AddPackageRepository",
      I: AddPackageRepositoryRequest,
      O: AddPackageRepositoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerRepositoriesService.GetPackageRepositoryDetail
     */
    getPackageRepositoryDetail: {
      name: "GetPackageRepositoryDetail",
      I: GetPackageRepositoryDetailRequest,
      O: GetPackageRepositoryDetailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerRepositoriesService.GetPackageRepositorySummaries
     */
    getPackageRepositorySummaries: {
      name: "GetPackageRepositorySummaries",
      I: GetPackageRepositorySummariesRequest,
      O: GetPackageRepositorySummariesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerRepositoriesService.UpdatePackageRepository
     */
    updatePackageRepository: {
      name: "UpdatePackageRepository",
      I: UpdatePackageRepositoryRequest,
      O: UpdatePackageRepositoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerRepositoriesService.DeletePackageRepository
     */
    deletePackageRepository: {
      name: "DeletePackageRepository",
      I: DeletePackageRepositoryRequest,
      O: DeletePackageRepositoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc kubeappsapis.plugins.kapp_controller.packages.v1alpha1.KappControllerRepositoriesService.GetPackageRepositoryPermissions
     */
    getPackageRepositoryPermissions: {
      name: "GetPackageRepositoryPermissions",
      I: GetPackageRepositoryPermissionsRequest,
      O: GetPackageRepositoryPermissionsResponse,
      kind: MethodKind.Unary,
    },
  },
} as const;
